import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFamily = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4676 12.7501C31.3266 12.8925 31.1856 13.0352 31.0445 13.1779C30.4364 13.7933 29.8281 14.4087 29.2198 15.0241C28.8387 15.4098 28.4576 15.7952 28.0766 16.1808C27.5366 16.7271 26.6192 16.7148 26.0789 16.1808C26.0077 16.1103 25.9364 16.0398 25.865 15.9693C25.3646 15.4747 24.8641 14.9801 24.3635 14.4855C24.0922 14.217 23.9665 13.8598 23.9498 13.4864C23.933 13.1103 24.1164 12.7571 24.3635 12.4876C24.6021 12.2281 25.0159 12.0741 25.3624 12.0741C25.7268 12.0741 26.1026 12.232 26.3612 12.4876C26.4325 12.5581 26.5039 12.6286 26.5751 12.6991C26.7388 12.861 26.9024 13.0226 27.0661 13.1845C27.4863 12.7594 27.9066 12.334 28.3269 11.9089C28.7078 11.5232 29.0889 11.1379 29.4699 10.7522C29.7381 10.4811 30.0953 10.3553 30.4688 10.3387C30.8449 10.3219 31.1985 10.5053 31.4676 10.7522C31.7275 10.9909 31.8811 11.4047 31.8811 11.7513C31.8811 12.1155 31.7232 12.4912 31.4676 12.7501ZM27.9158 5.00082C23.2992 5.00082 19.5566 8.74306 19.5566 13.3596C19.5566 17.9762 23.2992 21.7188 27.9158 21.7188C32.5323 21.7188 36.2749 17.9762 36.2749 13.3596C36.2749 8.74306 32.5323 5.00082 27.9158 5.00082Z",
			fill: "url(#paint0_linear_2676_23191)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.9913 32.3821C34.9913 36.3553 31.7704 39.5762 27.7975 39.5762C23.8243 39.5762 20.6035 36.3553 20.6035 32.3821C20.6035 28.409 23.8243 25.1882 27.7975 25.1882C31.7704 25.1882 34.9913 28.409 34.9913 32.3821Z",
			fill: "url(#paint1_linear_2676_23191)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.9913 32.3821C34.9913 36.3553 31.7704 39.5762 27.7975 39.5762C23.8243 39.5762 20.6035 36.3553 20.6035 32.3821C20.6035 28.409 23.8243 25.1882 27.7975 25.1882C31.7704 25.1882 34.9913 28.409 34.9913 32.3821Z",
			fill: "black",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.7792 50.1779L41.1088 46.7237C40.4066 43.1076 37.2401 40.4965 33.5565 40.4965H22.4182C18.7448 40.4965 15.5837 43.0936 14.8712 46.6975L14.166 50.2639C23.2625 51.9712 32.5994 51.948 41.6875 50.1954L41.7792 50.1779Z",
			fill: "url(#paint2_linear_2676_23191)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.7792 50.1779L41.1088 46.7237C40.4066 43.1076 37.2401 40.4965 33.5565 40.4965H22.4182C18.7448 40.4965 15.5837 43.0936 14.8712 46.6975L14.166 50.2639C23.2625 51.9712 32.5994 51.948 41.6875 50.1954L41.7792 50.1779Z",
			fill: "black",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2256 34.0603C19.2256 37.728 16.2523 40.7012 12.5845 40.7012C8.91662 40.7012 5.94336 37.728 5.94336 34.0603C5.94336 30.3922 8.91662 27.4191 12.5845 27.4191C16.2523 27.4191 19.2256 30.3922 19.2256 34.0603Z",
			fill: "url(#paint3_linear_2676_23191)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2256 34.0603C19.2256 37.728 16.2523 40.7012 12.5845 40.7012C8.91662 40.7012 5.94336 37.728 5.94336 34.0603C5.94336 30.3922 8.91662 27.4191 12.5845 27.4191C16.2523 27.4191 19.2256 30.3922 19.2256 34.0603Z",
			fill: "black",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9398 51.466L12.727 51.2385L13.6715 46.4614C14.0575 44.5092 15.071 42.8079 16.4762 41.5516H7.61824C4.22703 41.5516 1.30895 43.949 0.651114 47.2758L0 50.5685H0.000129065C5.00706 51.508 10.093 51.8794 15.162 51.6837C14.7539 51.6139 14.3464 51.5424 13.9398 51.466Z",
			fill: "url(#paint4_linear_2676_23191)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9398 51.466L12.727 51.2385L13.6715 46.4614C14.0575 44.5092 15.071 42.8079 16.4762 41.5516H7.61824C4.22703 41.5516 1.30895 43.949 0.651114 47.2758L0 50.5685H0.000129065C5.00706 51.508 10.093 51.8794 15.162 51.6837C14.7539 51.6139 14.3464 51.5424 13.9398 51.466Z",
			fill: "black",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.7734 34.0599C36.7734 37.7276 39.747 40.7012 43.4147 40.7012C47.0825 40.7012 50.0557 37.7276 50.0557 34.0599C50.0557 30.3922 47.0825 27.4187 43.4147 27.4187C39.747 27.4187 36.7734 30.3922 36.7734 34.0599Z",
			fill: "url(#paint5_linear_2676_23191)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.7734 34.0599C36.7734 37.7276 39.747 40.7012 43.4147 40.7012C47.0825 40.7012 50.0557 37.7276 50.0557 34.0599C50.0557 30.3922 47.0825 27.4187 43.4147 27.4187C39.747 27.4187 36.7734 30.3922 36.7734 34.0599Z",
			fill: "black",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.06 51.4661L43.2726 51.2383L42.3281 46.4612C41.9421 44.5094 40.9288 42.8081 39.5234 41.5514H48.3814C51.7728 41.5514 54.6907 43.9492 55.3485 47.2759L55.9997 50.5684C50.9925 51.5081 45.9068 51.8796 40.8377 51.6836C41.2456 51.6141 41.6534 51.5422 42.06 51.4661Z",
			fill: "url(#paint6_linear_2676_23191)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.06 51.4661L43.2726 51.2383L42.3281 46.4612C41.9421 44.5094 40.9288 42.8081 39.5234 41.5514H48.3814C51.7728 41.5514 54.6907 43.9492 55.3485 47.2759L55.9997 50.5684C50.9925 51.5081 45.9068 51.8796 40.8377 51.6836C41.2456 51.6141 41.6534 51.5422 42.06 51.4661Z",
			fill: "black",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2676_23191",
				x1: 20.6766,
				y1: 25.3062,
				x2: 30.3501,
				y2: 5.22871,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0C7BAA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#049986"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2676_23191",
				x1: 21.5673,
				y1: 42.6636,
				x2: 29.8928,
				y2: 25.3846,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0186BF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01BFA7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_2676_23191",
				x1: 16.0158,
				y1: 53.8944,
				x2: 19.0453,
				y2: 38.1547,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0186BF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01BFA7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_2676_23191",
				x1: 6.83311,
				y1: 43.5513,
				x2: 14.5186,
				y2: 27.6002,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0186BF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01BFA7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_2676_23191",
				x1: 1.1037,
				y1: 53.9194,
				x2: 5.22519,
				y2: 40.0788,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0186BF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01BFA7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_2676_23191",
				x1: 37.6632,
				y1: 43.5514,
				x2: 45.3491,
				y2: 27.6,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0186BF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01BFA7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_2676_23191",
				x1: 40.6271,
				y1: 53.9195,
				x2: 44.7487,
				y2: 40.0786,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0186BF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01BFA7"
				})]
			})
		] })
	]
});
export default SvgFamily;
